import React from 'react';
import { useField } from 'formik';
import { SparkImageGallery } from '../UI/SparkImageGallery';
import { Box } from '@mui/material';

type SparkFormImageGalleryProps = {
  name: string;
  maxImagesCount?: number;
};

type ImagePreviews = { preview: string };
export type ImageFile = File & ImagePreviews;

export type SparkGalleryImagesType = ImageFile | ImagePreviews;

const SparkFormImageGallery = ({
  name,
  maxImagesCount,
}: SparkFormImageGalleryProps) => {
  const fieldConfig = useField<ImagePreviews[]>(name);
  const [{ value: sparkImages }] = fieldConfig;
  const helpers = fieldConfig[2];

  const [images, setImages] =
    React.useState<SparkGalleryImagesType[]>(sparkImages);

  React.useEffect(() => {
    setImages(sparkImages);
  }, [sparkImages]);

  const handleChange = (images: SparkGalleryImagesType[]) => {
    helpers.setValue(images);
    setImages(images);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <SparkImageGallery
        onSave={handleChange}
        images={images}
        maxImagesCount={maxImagesCount}
      />
    </Box>
  );
};

export default SparkFormImageGallery;
